module.exports = __webpack_public_path__ + "static/media/github-run-workflow.adc741b9.png";